import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Intro.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const PresentationSolution = ({ scrollToRef }) => {
  return (
    <div className={styles.section} ref={scrollToRef}>
      <div className={cn("container", styles.container)}>
        <div className={styles.gallery}>
          {/* Image principale au centre */}
          <div className={styles.mainImage}>
            <ScrollParallax animateIn="fadeInUp" offset={200}>
              <img
                src="/images/content/illusp1.svg"
                alt="Interface principale"
                className={styles.centralImage}
              />
            </ScrollParallax>
          </div>
          
          {/* SVG flottants autour */}
          <ScrollParallax 
            className={styles.floatingElement} 
            animateIn="fadeInLeft" 
            offset={300}
            style={{
              position: 'absolute',
              top: '8%',
              left: '2%',
              zIndex: 2
            }}
          >
            <img
              src="/images/content/illusp32.svg"
              alt="Élément flottant 1"
              className={styles.floatingSmall}
            />
          </ScrollParallax>
          
          <ScrollParallax 
            className={styles.floatingElement} 
            animateIn="fadeInRight" 
            offset={400}
            style={{
              position: 'absolute',
              top: '15%',
              right: '2%',
              zIndex: 3
            }}
          >
            <img
              src="/images/content/illusp33.svg"
              alt="Élément flottant 2"
              className={styles.floatingMedium}
            />
          </ScrollParallax>
          
          <ScrollParallax 
            className={styles.floatingElement} 
            animateIn="fadeInUp" 
            offset={500}
            style={{
              position: 'absolute',
              bottom: '-15%',
              left: '8%',
              zIndex: 1
            }}
          >
            <img
              src="/images/content/illusp4.svg"
              alt="Élément flottant 3"
              className={styles.floatingLarge}
            />
          </ScrollParallax>
        </div>
        <div className={styles.wrap}>
          <h2 className={cn("h1", styles.title)}>
            Maîtrisez votre trésorerie
          </h2>
          <div className={styles.text}>
            Transformez votre gestion financière avec une facturation intelligente et automatisée. Suivez vos encaissements en temps réel, anticipez vos flux de trésorerie et ne laissez plus aucun euro vous échapper grâce à notre système de veille OPCO intégré.
          </div>
          <Link className={cn("button", styles.button)} to="/opco">
            En savoir plus
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PresentationSolution;
